
export const branchApiNm = {
  //====================================== Branch Master =====================================
  generateJobNo: "/branch/generateJobNo",
  generateRcptNo: "/branch/generateRcptNo",
  generateRcptXpssDocNum: "/branch/generateRcptXpssDocNum",
  generateInvoiceNo: "/branch/generateInvoiceNo",
  generateBillingNoteNo: "/branch/generateBillingNoteNo",
  generateScInvXpssDocNum: "/branch/generateScInvXpssDocNum",
  insertTripAmnt: "/branch/insertTripAmntFromJobOrderTransfer",
  //==========================================================================================
}